export const INSTANCE_PATH = 'auth';

export enum RESPONSE_ERROR {
    INVALID_TOTP = 'INVALID_TOTP',
    INVALID_IP = 'INVALID_IP',
}
